import type { GridColDef } from '@mui/x-data-grid-pro';
import type { PredefinedValuesByColumn } from '../types';

export const filterImportColumnsByPreference = (
    columns: GridColDef[],
    columnPreferences: Record<string, boolean>
): GridColDef[] => {
    const filteredColumns = columns.filter((column) => columnPreferences[column.field] !== false);
    return filteredColumns;
};

export const validateImportLookupValue = (
    field: string,
    value: string | undefined,
    predefinedValuesByColumn: PredefinedValuesByColumn = {}
): string | undefined => {
    const predefinedValues = predefinedValuesByColumn[field];
    if (predefinedValues === undefined) {
        return value;
    }

    const matchingValue = value === undefined
        ? undefined
        : predefinedValues.find((predefinedValue) => predefinedValue.toLowerCase() === value.toLowerCase());
    const validatedValue = matchingValue ?? '';
    return validatedValue;
};